(function() {
  const initFrequentlyBoughtTogether = (container) => {
    if (!container || container.dataset.fbtInitialized === 'true') return;

    container.dataset.fbtInitialized = 'true';

    const items = Array.from(container.querySelectorAll('[data-fbt-item]'));
    const total = container.querySelector('[data-fbt-total]');
    const count = container.querySelector('[data-fbt-count]');
    const button = container.querySelector('.fbt__button');

    const update = () => {
      let totalPrice = 0;
      let selectedCount = 0;

      items.forEach((item) => {
        const toggle = item.querySelector('[data-fbt-toggle]');
        const input = item.querySelector('[data-fbt-id-input]');
        const isSelected = Boolean(toggle && toggle.checked && input);

        item.classList.toggle('is-selected', isSelected);
        item.classList.toggle('is-unselected', Boolean(toggle && !toggle.checked));

        if (input) {
          if (isSelected) {
            input.name = 'id';
            input.disabled = false;
            totalPrice += Number.parseInt(item.dataset.priceCents || '0', 10);
            selectedCount += 1;
          } else {
            input.removeAttribute('name');
            input.disabled = true;
          }
        }
      });

      if (total && window.theme?.Currency && window.theme?.shopSettings?.moneyFormat) {
        total.innerHTML = `<price-money><bdi>${window.theme.Currency.formatMoney(totalPrice, window.theme.shopSettings.moneyFormat)}</bdi></price-money>`;
      }

      if (count) {
        const singular = count.dataset.singularLabel || 'item';
        const plural = count.dataset.pluralLabel || 'items';
        count.textContent = `(${selectedCount} ${selectedCount === 1 ? singular : plural})`;
      }

      if (button) {
        button.disabled = selectedCount === 0;
      }
    };

    items.forEach((item) => {
      const toggle = item.querySelector('[data-fbt-toggle]');
      if (toggle) toggle.addEventListener('change', update);
    });

    update();
  };

  const initAllFrequentlyBoughtTogether = (root = document) => {
    root.querySelectorAll('[data-fbt]').forEach(initFrequentlyBoughtTogether);
  };

  document.addEventListener('DOMContentLoaded', () => initAllFrequentlyBoughtTogether());
  document.addEventListener('page:loaded', () => initAllFrequentlyBoughtTogether());
  document.addEventListener('shopify:section:load', (event) => initAllFrequentlyBoughtTogether(event.target));
})();
